import React, { isValidElement } from 'react';

export function extractTextFromJSX(element?: React.ReactNode | null): string {
  if (!element) {
    return '';
  }

  if (typeof element === 'string' || typeof element === 'number') {
    return element.toString();
  }
  if (isValidElement<React.PropsWithChildren>(element)) {
    return extractTextFromJSX(element.props.children);
  }
  if (Array.isArray(element)) {
    return element.map((child) => extractTextFromJSX(child)).join('');
  }
  return '';
}
